import store from "../../../redux/store";
import {
    handleClearAllSelectedResources,
    handleSelectResources,
    handleSetDeleteConfirmationModalStatus,
    handleSetTrashConfirmationModalStatus,
    handleSetDownloadConfirmationModalStatus,
    handleSetPreviewModalStatus,
    handleSetUnshareConfimrationModalStatus
} from "./fileManager.actions";
import { getFileExtension, getFileManagerParent, isFolder, previewValidFormats } from "../../../scripts/helpers";
import { createBrowserHistory } from "history";
import PATH from "../../../urls/path";
import { unsharedResources } from "./fileManager.function";

export function keyboardListener() {
    const fileManager = store.getState().fileManager;
    document.onkeyup = (e) => {
        e.preventDefault();
        if (e.ctrlKey && (e.keyCode === 65 || e.keyCode === 97)) {
            const liveFileManagerStore = store.getState().fileManager;
            const actionStatus = [
                liveFileManagerStore.publicLinkModalStatus,
                liveFileManagerStore.publicLinkFolderModalStatus,
                liveFileManagerStore.shareModalStatus,
                liveFileManagerStore.shareCutModalStatus,
                liveFileManagerStore.cutModalStatus,
                liveFileManagerStore.renameModalStatus,
                liveFileManagerStore.previewModalStatus,
                liveFileManagerStore.contextMenuStatus,
                liveFileManagerStore.newFolderModalStatus,
                liveFileManagerStore.linkUploadModalStatus,
                liveFileManagerStore.informationModalStatus,
                liveFileManagerStore.trashConfirmationModalStatus,
                liveFileManagerStore.deleteConfirmationModalStatus
            ].every((status) => !status);
            if (actionStatus) {
                if (fileManager.resources) {
                    handleSelectResources(fileManager.resources!);
                }
            }
        }
    };
}

export function keyboardHandler(e: any, navigate: any = false, location: any = false) {
    const fileManager = store.getState().fileManager;
    if (fileManager.selectedResources.length === 0) {
        if (e.code === "ArrowDown" || e.code === "ArrowUp" || e.code === "ArrowLeft" || e.code === "ArrowRight") {
            handleSelectResources([fileManager.filteredResources[0]]);
        }
    } else {
        if (fileManager.filteredResources.length > 1 && fileManager.selectedResources.length <= 1) {
            const fileManagerWrapperElement = document.getElementById("fileManager");
            const resourceCardElement = document.querySelector(".resource-card");
            if (fileManagerWrapperElement && resourceCardElement) {
                const currentSelectedPosition = fileManager.filteredResources.findIndex(
                    (resource) => resource.id === fileManager.selectedResources[0].id
                );
                const rowColumnsCount = Math.floor(fileManagerWrapperElement?.offsetWidth / resourceCardElement?.clientWidth);
                const resourcesCount = fileManager.filteredResources.length;
                if (e.code === "ArrowDown") {
                    if (currentSelectedPosition + rowColumnsCount < resourcesCount) {
                        handleSelectResources([fileManager.filteredResources[currentSelectedPosition + rowColumnsCount]]);
                        const id = fileManager.filteredResources[currentSelectedPosition + rowColumnsCount].id;
                        const el = document.querySelector(`[data-resource-id="${id}"]`);
                        el?.scrollIntoView({ block: "center", behavior: "smooth" });
                    } else {
                        handleSelectResources([fileManager.filteredResources[resourcesCount - 1]]);
                    }
                }
                if (e.code === "ArrowUp") {
                    if (currentSelectedPosition - rowColumnsCount >= 0) {
                        handleSelectResources([fileManager.filteredResources[currentSelectedPosition - rowColumnsCount]]);
                        const id = fileManager.filteredResources[currentSelectedPosition - rowColumnsCount].id;
                        const el = document.querySelector(`[data-resource-id="${id}"]`);
                        el?.scrollIntoView({ block: "center", behavior: "smooth" });
                    }
                }
                if (e.code === "ArrowLeft") {
                    if (currentSelectedPosition + 1 !== resourcesCount) {
                        handleSelectResources([fileManager.filteredResources[currentSelectedPosition + 1]]);
                        const id = fileManager.filteredResources[currentSelectedPosition + 1].id;
                        const el = document.querySelector(`[data-resource-id="${id}"]`);
                        el?.scrollIntoView({ block: "center", behavior: "smooth" });
                    }
                }
                if (e.code === "ArrowRight") {
                    if (currentSelectedPosition + 1 !== 1) {
                        handleSelectResources([fileManager.filteredResources[currentSelectedPosition - 1]]);
                        const id = fileManager.filteredResources[currentSelectedPosition - 1].id;
                        const el = document.querySelector(`[data-resource-id="${id}"]`);
                        el?.scrollIntoView({ block: "center", behavior: "smooth" });
                    }
                }
            }
        }
        if (fileManager.selectedResources.length > 0) {
            if (e.code === "Escape") {
                handleClearAllSelectedResources();
            }
            if (e.code === "Delete") {
                const history = createBrowserHistory();
                if (store.getState().fileManager.selectedResources.length > 0) {
                    if (history.location.pathname === PATH.trash) {
                        handleSetDeleteConfirmationModalStatus(true);
                    } else if (history.location.pathname === PATH.shared) {
                        handleSetUnshareConfimrationModalStatus(true);
                    } else {
                        handleSetTrashConfirmationModalStatus(true);
                    }
                }
            }
        }
    }
    if (location && navigate) {
        if (fileManager.selectedResources.length === 1) {
            if (e.code === "Enter") {
                if (location.pathname === PATH.shared) {
                    navigate(`${PATH.shared}/?path=${fileManager.selectedResources[0].id}`);
                } else {
                    if (isFolder(fileManager.selectedResources[0])) navigate(`/${PATH.files}?path=${fileManager.selectedResources[0].id}`);
                    else if (!previewValidFormats.includes(getFileExtension(fileManager.selectedResources[0].name)!))
                        handleSetDownloadConfirmationModalStatus(true);
                    else handleSetPreviewModalStatus(true);
                }
            }
        }
        if (e.code === "Backspace") {
            if (getFileManagerParent()) {
                navigate(-1);
            }
        }
    }
}
